(function() {
  function fetchVariants(handle) {
    return fetch('/products/' + handle + '.js').then(function(r) { return r.json(); });
  }

  function refreshCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer');
    var isCartPage = window.location.pathname === '/cart';

    if (isCartPage) {
      return fetch(window.location.pathname + '?section_id=main-cart-items')
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var newDoc = new DOMParser().parseFromString(html, 'text/html');
          var newItems = newDoc.querySelector('#main-cart-items') || newDoc.querySelector('cart-items');
          var oldItems = document.querySelector('#main-cart-items') || document.querySelector('cart-items');
          if (newItems && oldItems) oldItems.innerHTML = newItems.innerHTML;
          return fetch(window.location.pathname + '?section_id=main-cart-footer').then(function(r) { return r.text(); });
        })
        .then(function(html) {
          var newDoc = new DOMParser().parseFromString(html, 'text/html');
          var newFooter = newDoc.querySelector('#main-cart-footer') || newDoc.querySelector('cart-footer');
          var oldFooter = document.querySelector('#main-cart-footer') || document.querySelector('cart-footer');
          if (newFooter && oldFooter) oldFooter.innerHTML = newFooter.innerHTML;
        });
    }

    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      return fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          return fetch('/?sections=cart-drawer,cart-icon-bubble')
            .then(function(r) { return r.json(); })
            .then(function(sections) {
              cart.sections = sections;
              cartDrawer.renderContents(cart);
            });
        });
    }

    return fetch('/?section_id=cart-drawer')
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var newDoc = new DOMParser().parseFromString(html, 'text/html');
        var newDrawer = newDoc.querySelector('cart-drawer');
        var oldDrawer = document.querySelector('cart-drawer');
        if (newDrawer && oldDrawer) oldDrawer.innerHTML = newDrawer.innerHTML;
      });
  }

  function buildTiles(container) {
    var handle = container.dataset.productHandle;
    var currentColor = container.dataset.currentColor;
    var currentDesign = container.dataset.currentDesign;
    var engravingUrl = container.dataset.engravingUrl;
    var placementUrl = container.dataset.placementUrl;
    var designId = container.dataset.designId;
    var tilesEl = container.querySelector('[data-cc-tiles]');

    fetchVariants(handle).then(function(product) {
      var colorOption = null;
      var designOption = null;
      product.options.forEach(function(o, i) {
        if (o.name === 'Color') colorOption = { idx: i, values: o.values };
        if (o.name === 'Design') designOption = { idx: i, values: o.values };
      });
      if (!colorOption) {
        tilesEl.innerHTML = '';
        return;
      }

      var matchingVariants = product.variants.filter(function(v) {
        if (!v.available) return false;
        if (v.options[colorOption.idx] === currentColor) return false;
        if (designOption && currentDesign && v.options[designOption.idx] !== currentDesign) return false;
        return true;
      });

      var seenColors = {};
      matchingVariants = matchingVariants.filter(function(v) {
        var color = v.options[colorOption.idx];
        if (seenColors[color]) return false;
        seenColors[color] = true;
        return true;
      });

      if (!matchingVariants.length) {
        tilesEl.innerHTML = '<span class="cc-duplicate-color__loading">No other colors available</span>';
        return;
      }

      tilesEl.innerHTML = '';
      matchingVariants.forEach(function(v) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cc-duplicate-color__tile';
        btn.title = v.options[colorOption.idx];
        btn.dataset.variantId = v.id;

        var img = document.createElement('img');
        img.src = v.featured_image ? v.featured_image.src : (product.featured_image || '');
        img.alt = v.options[colorOption.idx];
        img.loading = 'lazy';
        btn.appendChild(img);

        btn.addEventListener('click', function() {
          addVariantWithDesign(v.id, engravingUrl, placementUrl, designId, btn);
        });

        tilesEl.appendChild(btn);
      });
    }).catch(function() {
      tilesEl.innerHTML = '<span class="cc-duplicate-color__loading">Could not load colors</span>';
    });
  }

  function addVariantWithDesign(variantId, engravingUrl, placementUrl, designId, btn) {
    btn.disabled = true;

    var properties = {};
    if (engravingUrl) properties['Engraving File'] = engravingUrl;
    if (placementUrl) properties['Placement Preview'] = placementUrl;
    if (designId) properties['_design_id'] = designId;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: properties }]
      })
    }).then(function(r) {
      if (!r.ok) throw new Error('Add failed');
      return r.json();
    }).then(function() {
      return refreshCartDrawer();
    }).catch(function() {
      btn.disabled = false;
      console.warn('Could not add variant to cart');
    });
  }

  function init() {
    document.querySelectorAll('.cc-duplicate-color:not([data-cc-initialized])').forEach(function(el) {
      el.dataset.ccInitialized = 'true';
      buildTiles(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  new MutationObserver(init).observe(document.body, { childList: true, subtree: true });
})();